import script from "./ScheduleDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleDetails.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleDetails.vue?vue&type=style&index=0&id=3998171a&lang=scss"
import "./ScheduleDetails.vue?vue&type=style&index=1&id=3998171a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3998171a"]])

export default __exports__